import { createSlice } from '@reduxjs/toolkit';
import { INewsState } from '../types';
import { getNews } from '../../service/api';

const initialState: INewsState = {
  page: null,
  pending: false,
  error: null,
};

export const newsSlice = createSlice({
  name: 'newsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNews.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getNews.fulfilled, (state, action) => {
        state.page = action.payload;
        state.pending = false;
      })
      .addCase(getNews.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export default newsSlice.reducer;
